module.exports = __webpack_public_path__ + "static/img/6.6c8cbf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/eng/6.png
// module id = X/gc
// module chunks = 0